import { Modal } from "antd";
import CreateTeamForm from "./CreateTeamForm";

const EditTeam = ({ team, isOpen, closeModal }) => {
  return (
    <Modal
      title={<></>}
      width="500px"
      open={isOpen}
      onCancel={closeModal}
      className="user-popup"
      footer={false}
    >
      <div className="mt20">
        <CreateTeamForm initialValues={team} closeModal={closeModal} />
      </div>
    </Modal>
  );
};

export default EditTeam;
